import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import DashboardFooter from "../../components/DashBoardFooter/dashboardFooter";
import Preloader from "../../components/preloader/Preloader";
import SideBarNav from "../../components/sideBarNav/sideBarNav";
import UserAccountWrapper from "../../components/userAcountWrapper/userAccountWrapper";
import { auth, firestore } from "../../db/config";
import DepositTable from "./depositTable";

export default function DepositList() {
  const [userDeposit, setuserDeposit] = useState("");
  const [pageState, setpageState] = useState({
    loader: false,
    userId: "",
    emptyMessage: "",
    lastDocs: "",
    tabState: "active",
  });

  const handleFetchStatus = (status) => {
    setpageState({
      ...pageState,
      tabState: status,
      loader: true,
    });

    auth.onAuthStateChanged((user) => {
      var query = firestore.collection("deposit");

      query = query.where("status", "==", status);
      query = query.where("userId", "==", user.uid);
      query = query.orderBy("investmentTime", "desc").limit(10);
      query.get().then((depo) => {
        if (depo.size === 0) {
          setpageState({
            ...pageState,
            emptyMessage: "No record found",
            loader: false,
          });
        } else {
          const depoMap = depo.docs.map((data) => data.data());
          const lastDocs = depo.docs[depo.docs.length - 1];
          setuserDeposit(depoMap);
          setpageState({
            ...pageState,
            lastDocs,
            emptyMessage: "",
            tabState: status,
            loader: false,
          });
        }
      });
    });
  };
  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      var query = firestore.collection("deposit");
      query = query.where("status", "==", "active");
      query = query.where("userId", "==", user.uid);
      query = query.orderBy("investmentTime", "desc").limit(10);
      query.get().then((depo) => {
        if (depo.size === 0) {
          setpageState({
            ...pageState,
            emptyMessage: "No record found",
          });
        } else {
          const depoMap = depo.docs.map((data) => data.data());
          const lastDocs = depo.docs[depo.docs.length - 1];
          setuserDeposit(depoMap);
          setpageState({
            ...pageState,
            lastDocs,
          });
        }
      });
    });
  }, []);
  const handleLoadMore = () => {
    setpageState({
      ...pageState,
      loader: true,
    });
    auth.onAuthStateChanged((user) => {
      var query = firestore.collection("deposit");
      query = query.where("status", "==", pageState.tabState);
      query = query.where("userId", "==", user.uid);
      query = query
        .orderBy("investmentTime", "desc")
        .startAfter(pageState.lastDocs)
        .limit(10);
      query.get().then((depo) => {
        if (depo.size === 0) {
          setpageState({
            ...pageState,
            emptyMessage: "No more Data to load....",
            loader: false,
          });
        } else {
          const bookMap = depo.docs.map((data) => data.data());
          const lastDocs = depo.docs[depo.docs.length - 1];
          setuserDeposit(bookMap);
          setpageState({ ...pageState, lastDocs, loader: false });
        }
      });
    });
  };
  return (
    <div>
      <AboutHeader />
      <div class="page_title_section dashboard_title">
        <div class="page_header">
          <div class="container">
            <div class="row">
              <div class="col-xl-9 col-lg-7 col-md-7 col-12 col-sm-7">
                <h1>Deposit Lists </h1>
              </div>
              <div class="col-xl-3 col-lg-5 col-md-5 col-12 col-sm-5">
                <div class="sub_title_section">
                  <ul class="sub_title">
                    <li>
                      {" "}
                      <a href="/"> Home </a>&nbsp; / &nbsp;{" "}
                    </li>
                    <li> Deposit Lists</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SideBarNav />
      <div class="l-main">
        <UserAccountWrapper />
        <div class="deposit_list_wrapper float_left">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="sv_heading_wraper">
                <h3>deposit lists</h3>
              </div>
            </div>
          </div>
          <div class="crm_customer_table_main_wrapper deposit_tables float_left">
            <div class="row">
              <div class="col-md-12 col-lg-12 col-sm-12 col-12">
                <div class="deposit_tab_wrapper">
                  <ul class="nav nav-tabs">
                    <li class="nav-item">
                      {" "}
                      <a
                        class="nav-link active"
                        data-toggle="tab"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleFetchStatus("active")}
                      >
                        {" "}
                        active deposit
                      </a>
                    </li>
                    <li class="nav-item">
                      {" "}
                      <a
                        class="nav-link "
                        data-toggle="tab"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleFetchStatus("mature")}
                      >
                        matured deposit
                      </a>
                    </li>
                    <li class="nav-item">
                      {" "}
                      <a
                        class="nav-link"
                        data-toggle="tab"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleFetchStatus("pending")}
                      >
                        {" "}
                        pending deposit
                      </a>
                    </li>
                  </ul>
                </div>
                {pageState.loader ? (
                  <Preloader />
                ) : (
                  <div>
                    {pageState.emptyMessage ? (
                      <div
                        style={{
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src="images/bank.png"
                            alt="img"
                            style={{ objectFit: "contain" }}
                          />
                        </div>
                        <div style={{ textAlign: "center" }}>
                          {pageState.emptyMessage}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="table-responsive-sm">
                          <table class="table">
                            <thead class="thead-light">
                              <tr>
                                <th scope="col">Plan</th>
                                <th scope="col">Amount($)</th>
                                <th scope="col">Status</th>
                                <th scope="col">Payment Method</th>

                                <th scope="col">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {userDeposit
                                ? userDeposit.map((list, index) => {
                                    return (
                                      <DepositTable details={{ ...list }} />
                                    );
                                  })
                                : ""}
                            </tbody>
                          </table>
                        </div>
                        <div style={{ marginTop: "20px" }}>
                          <a
                            style={{
                              background: "#00aaef",
                              paddingLeft: "30px",
                              paddingRight: "30px",
                              paddingTop: "10px",
                              paddingBottom: "10px",
                              borderRadius: "26px",
                              color: "white",
                              cursor: "pointer",
                            }}
                            onClick={handleLoadMore}
                          >
                            Load More
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <DashboardFooter />
      </div>
    </div>
  );
}
